module.exports = __webpack_public_path__ + "static/img_emergency_process_02@2x-4c1ebd78dc3ac1ff3e2ef53033ca711f.png";